<ion-textarea
	*ngIf="showComment"
	(ionInput)="onCommentChange($event)"
	[autoGrow]="true"
	[value]="commentModel"
	fill="outline"
	label="{{ 'CHECKLISTS__COMMENT_PLACEHOLDER' | transloco }}"
	[labelPlacement]="isV2() ? 'stacked' : 'floating'"
	debounce="200"
	[rows]="isV2() ? 3 : undefined"
></ion-textarea>
